import {AfterContentInit, Component, Inject} from '@angular/core'
import {FormControl, Validators} from '@angular/forms'
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog'
import {UpdateWishlistCommand, UpdateWishlistGQL, Wishlist} from '../../../../../graphql'
import {UnsubscribeOnDestroy} from '../../../../utility'
import {MatSnackBar} from "@angular/material/snack-bar";
import { Amplitude, HotKey } from '../../../../injectable'

@Component({
    selector: 'app-update-wishlist',
    templateUrl: 'update-wishlist.html'
})
export class UpdateWishlistComponent extends UnsubscribeOnDestroy implements AfterContentInit {
    wishlist: Wishlist
    nameControl: FormControl
    statusControl: FormControl

    // Constructor
    constructor(private _amplitude: Amplitude,
                private _dialogRef: MatDialogRef<UpdateWishlistComponent>,
                private _hotKey: HotKey,
                @Inject(MAT_DIALOG_DATA) public updateWishlistData: UpdateWishlistData,
                private _updateWishlistGQL: UpdateWishlistGQL,
                private _snackBar: MatSnackBar) {
        super()

        this.wishlist = updateWishlistData.wishlist

        this._subscriptions.push(this._hotKey.addShortcut({ keys: 'enter' }).subscribe(() => {
            this.updateWishlist()
        }))
    }

    ngAfterContentInit(): void {
        this.nameControl = new FormControl(this.wishlist.name, Validators.required)
        this.statusControl = new FormControl(this.wishlist.status, Validators.required)
    }

    // Public
    updateWishlist() {
        if (!this.nameControl.valid) { return }
        if (!this.statusControl.valid) { return }

        const command: UpdateWishlistCommand = {
            wishlistId: this.wishlist.wishlistId,
            name: this.nameControl.value,
        }
        this._subscriptions.push(this._updateWishlistGQL.mutate({ input: command }).subscribe(({ data }) => {
            this._amplitude.logEvent('Wishlist Updated', {
                wishlistId: command.wishlistId,
            })

            this._dialogRef.close(data.updateWishlist?.id)
        }, (error) => {
            this._snackBar.open('There was an error updating your wishlist, please try again later')
            console.error('Error updating wishlist', error)
        }))
    }
}

export class UpdateWishlistData {
    wishlist: Wishlist
}
